import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from "vue-router";

// import Home from "../components/home/Newsletter.vue";
import { defineAsyncComponent } from "vue"
import Platform from "@/config/platform";
import { getQueryVariable } from "@/uitls/uitls";
// import { nativeToLogin } from "@/uitls/native";
// import LoadingComponent from "@/components/Loading.vue"
const standalone = Platform.standalone;

const routes: Array<RouteRecordRaw> = [
  {
    path: standalone ? "/" : "/",
    name:  "Home",
    component: defineAsyncComponent(() => import('../views/home/Home.vue')),
    meta: { keepAlive: true, tab: true },
  },
  {
    path: standalone ? "/match" : "/match",
    name: "Match",
    meta: { tab: true, keepAlive: true },
    component: defineAsyncComponent(() => import('../views/match/Match.vue'))
  },
  {
    path: "/message",
    name: "Message",
    meta: { tab: true, keepAlive: true },
    component: defineAsyncComponent(() => import("../views/message/Message.vue"))
  },
  {
    path: "/friend",
    name: "Friend",
    meta: { tab: true },
    component: defineAsyncComponent(() => import("../views/friend/Friend.vue")),
  },
  {
    path: "/me",
    name: "Me",
    meta: { tab: true },
    component: defineAsyncComponent(() => import("../views/me/Me.vue")),
  },
  {
    path: "/login",
    name: "Login",
    component: defineAsyncComponent(() => import("../views/me/Login.vue")),
  },
  {
    path: "/player",
    name: "Player",
    component: defineAsyncComponent(() => import("../views/player/Player.vue")),
  },
  {
    path: "/play",
    name: "Play",
    component: defineAsyncComponent(() => import("../views/player/Player.vue")),
  },
  {
    path: "/chat",
    name: "Chat",
    component: defineAsyncComponent(() => import("../views/message/Chat.vue")),
  },

  {
    path: "/newfriend",
    name: "Newfriend",
    component: defineAsyncComponent(() => import("../views/friend/NewFriend.vue")),
  },
  {
    path: "/group",
    name: "Group",
    component: defineAsyncComponent(() => import("../views/friend/Group.vue")),
  },

  {
    path: "/Syssetting",
    name: "Syssetting",
    component: defineAsyncComponent(() => import("../views/me/Syssetting.vue")),
  },
  {
    path: "/Aboat",
    name: "Aboat",
    component: defineAsyncComponent(() => import("../views/me/Aboat.vue")),
  },
  {
    path: "/Changepwd",
    name: "Changepwd",
    component: defineAsyncComponent(() => import("../views/me/Changepwd.vue")),
  },
  // {
  //   path: "/#/Changepwd",
  //   name: "Changepwd",
  //   component: defineAsyncComponent(() => import("../views/me/Changepwd.vue")),
  // },
  {
    path: "/NewsDetail",
    name: "NewsDetail",
    component: defineAsyncComponent(() => import("../views/home/NewsDetail.vue")),
  },
  {
    path: "/MoreRecomm",
    name: "MoreRecomm",
    component: defineAsyncComponent(() => import("../views/home/MoreRecomm.vue")),
  },
  {
    path: "/History",
    name: "History",
    component: defineAsyncComponent(() => import("../views/me/History.vue")),
  },
  {
    path: "/Subscribe",
    name: "Subscribe",
    component: defineAsyncComponent(() => import("../views/me/Subscribe.vue")),
  },
  {
    path: "/ball",
    name: "Ball",
    component: defineAsyncComponent(() => import("../views/home/BallDetail.vue")),
  },
  {
    // path: "/integralwallet/:channel/:uid/:token/:nav",
    path: "/integralwallet",
    name: "Integralwallet",
    component: defineAsyncComponent(() => import("../views/me/Integralwallet.vue")),
  },
  {
    path: "/integralMyStore",
    name: "IntegralMyStore",
    component: defineAsyncComponent(() => import("../views/me/IntegralMyStore.vue")),
  },
  {
    path: "/integralAddress",
    name: "IntegralAddress",
    component: defineAsyncComponent(() => import("../views/me/IntegralAddress.vue")),
  },

  {
    path: "/search",
    name: "Search",
    component: defineAsyncComponent(() => import("../views/home/Search.vue")),
  },

  {
    path: "/IntegralExchange",
    name: "IntegralExchange",
    component: defineAsyncComponent(() => import("../views/me/IntegralExchange.vue")),
  },
  {
    path: "/integralrule",
    name: "integralrule",
    component: defineAsyncComponent(() => import("../views/me/integralrule.vue")),
  },
  {
    path: "/IntegralDetail",
    name: "IntegralDetail",
    component: defineAsyncComponent(() => import("../views/me/IntegralDetail.vue")),
  },
  {
    // path: "/viplevel/:channel/:uid/:token/:nav",
    path: "/viplevel",
    name: "VipLevels",
    component: defineAsyncComponent(() => import("../views/me/VipLevels.vue")),
  },
  {
    path: "/realname",
    name: "realname",
    component: defineAsyncComponent(() => import("../views/me/realname.vue")),
  },
  {
    path: "/passwordLogin",
    name: "PasswordLogin",
    component: defineAsyncComponent(() => import("../views/me/PasswordLogin.vue")),
  },
  {
    path: "/Setting",
    name: "Setting",
    component: defineAsyncComponent(() => import("../views/me/Setting.vue")),
  },
  {
    path: "/selfinfo",
    name: "selfinfo",
    component: defineAsyncComponent(() => import("../views/me/selfinfo.vue")),
  },
  {
    path: "/hotzb",
    name: "Hotzb",
    component: defineAsyncComponent(() => import("../views/home/HotZb.vue")),
  },
  {
    path: "/sign",
    name: "sign",
    component: defineAsyncComponent(() => import("../views/me/Sign.vue")),
  },
  {
    path: "/invitef",
    name: "invitef",
    component: defineAsyncComponent(() => import("../views/me/InviteFriend.vue")),
  },
  {
    path: "/inviteaward",
    name: "inviteaward",
    component: defineAsyncComponent(() => import("../views/me/InviteAward.vue")),
    // component: defineAsyncComponent(() => import("../views/me/InviteFriend.vue")), // 暂时关闭邀请兑换话费活动，使用旧版邀请好友代替
  },
  {
    path: "/lottery",
    name: "lottery",
    component: defineAsyncComponent(() => import("../views/me/LotteryEvent.vue")),
  },
  //意见反馈
  {
    path: "/proposal",
    name: "Proposal",
    component: defineAsyncComponent(() => import("../views/me/Proposal.vue")),
  },
  //活动中心
  {
    path: "/activity",
    name: "activity",
    component: defineAsyncComponent(() => import("../views/me/ActivityPage.vue")),
  },
  {
    path: "/activityDetail",
    name: "activityDetail",
    component: defineAsyncComponent(() => import("../views/me/ActivityDetail.vue")),
  },
  {
    path: "/lookid",
    name: "lookid",
    component: defineAsyncComponent(() => import("../views/me/LookId.vue")),
  },
  {
    path: "/imsearch",
    name: "search",
    component: defineAsyncComponent(() => import("../views/message/Search.vue")),
  },
  {
    path: "/blank",
    name: "Blank",
    component: defineAsyncComponent(() => import("../views/Blank.vue")),
  },
  {
    path: "/matchsetting",
    name: "MatchSetting",
    component: defineAsyncComponent(() => import('../views/match/MatchSetting.vue'))
  },
  {
    path: "/ann",
    name: "AnnMaintain",
    component: defineAsyncComponent(() => import('../views/home/AnnMaintain.vue'))
  },
  {
    path: "/vault",
    name: "Vault",
    component: defineAsyncComponent(() => import('../views/vault/Vault.vue'))
  },
  {
    path: "/delaccount",
    name: "DeleteAcc",
    component: defineAsyncComponent(() => import('../views/vault/DeleteAcc.vue'))
  },
  {
    path: "/emailVerification",
    name: "emailVerification",
    component: defineAsyncComponent(() => import('../views/me/emailVerification.vue')),
    meta: { keepAlive: true }
  },
  {
    path: "/setEmail",
    name: "setEmail",
    component: defineAsyncComponent(() => import('../views/me/SetEmail.vue'))
  },
  {
    path: "/pointGuessingActive",
    name: "PointGuessingActive",
    component:defineAsyncComponent(() => import('../views/me/PointGuessingActive.vue'))
  },
  {
    path: "/pointGuessingRecord",
    name: "PointGuessingRecord",
    component:defineAsyncComponent(() => import('../views/me/PointGuessingRecord.vue'))
  },
];


const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {

  // 如果当前路由为 /share，则重定向到 /inviteaward
  // if (to.path === '/share') {
  //   next({ path: '/inviteaward', replace: true });
  //   return;
  // }
  
  //如果有tab,全局隐藏底部tabbar
  const { os } = to.query;
  if (os && os != "h5") {
    to.meta.tab = false
  }

  if (to.fullPath.startsWith('/#')) {
    const fullPath = to.fullPath.replace(/^\/#/, '');
    next(fullPath);
    return;
  }

  if (window.navigator['standalone']) {
    // 真正的 iOS Web Clip / 添加到主屏幕，不做重定向以免破坏全屏模式
    to.query.webclip = "1";
    if (Platform.client != 'h5') {
      to.query.os = Platform.client;
    }
    next();
  } else {
    const needsWebclip = Platform.standalone && !to.query.webclip;
    const needsOs = Platform.client != 'h5' && to.query.os !== Platform.client;

    if (needsWebclip || needsOs) {
      const query = { ...to.query };
      if (needsWebclip) query.webclip = "1";
      if (needsOs) query.os = Platform.client;
      next({ path: to.path, query, replace: true });
    } else {
      next();
    }
  }
});

export default router;
